// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-33ec43fc]:export {\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.el-scrollbar[data-v-33ec43fc] {\n  height: 100%;\n}\n.has-logo .el-scrollbar[data-v-33ec43fc] {\n  height: calc(100% - 50px);\n}\n.el-menu[data-v-33ec43fc] {\n  border: none;\n  height: 100%;\n  width: 100% !important;\n}", ""]);
// Exports
module.exports = exports;
